import { useEffect, useRef } from 'react';

// Keep the existing table markup/calculations. On phone screens, attach the
// actual column headings to cells so CSS can present readable labelled rows.
export const useMobileTableCards = () => {
  const root = useRef(null);
  useEffect(() => {
    const element = root.current;
    if (!element) return undefined;
    const media = window.matchMedia('(max-width: 767px)');
    const labelCells = () => {
      if (!media.matches) return;
      element.querySelectorAll('table').forEach(table => {
        const grid = [];
        Array.from(table.tHead?.rows || []).forEach((row, ri) => {
          grid[ri] ||= [];
          let column = 0;
          Array.from(row.cells).forEach(cell => {
            while (grid[ri][column] != null) column++;
            const text = cell.textContent.replace(/\s+/g, ' ').trim();
            for (let r = ri; r < ri + cell.rowSpan; r++) {
              grid[r] ||= [];
              for (let c = column; c < column + cell.colSpan; c++) grid[r][c] = text;
            }
            column += cell.colSpan;
          });
        });
        Array.from(table.tBodies).forEach(body => Array.from(body.rows).forEach(row => {
          let column = 0;
          Array.from(row.cells).forEach(cell => {
            const label = [...new Set(grid.map(r => r[column]).filter(Boolean))].join(' · ');
            cell.dataset.mobileLabel = cell.colSpan > 1 ? '' : label;
            cell.dataset.mobileWide = cell.colSpan > 1 ? 'true' : 'false';
            column += cell.colSpan;
          });
        }));
      });
    };
    labelCells();
    media.addEventListener('change', labelCells);
    const observer = new MutationObserver(labelCells);
    observer.observe(element, { childList: true, subtree: true });
    return () => { observer.disconnect(); media.removeEventListener('change', labelCells); };
  }, []);
  return root;
};
